import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../bins/props/bins-configured-count';
import '../../common/bn-placeholder';
import '../../common/bn-icon-bin';
import '../../common/bn-icon';

class OrganizationBinCountHeader extends LitEntity {
  constructor() {
    super();
    this.binsHref = '';
    this.title = 'Total Bin Count';
  }

  static get properties() {
    return {
      binsHref: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
        float: left;
        margin-right: .25em;
      }
      .container {
        display: flex;
        justify-content: space-between;
        white-space: nowrap;
        width: 100%;
      }
      .count {
        margin: 0;
      }
      .divider {
        margin-left: .2em;
        color: var(--gray-50);
      }
      bn-icon-bin {
        width: .5em;
        margin-right: .2em;
      }
      bn-icon {
        font-size: .8em;
      }
    `];
  }

  render() {
    // Checking for no entity below removes flickering before we have enough information
    return html`
      ${renderIf(this.binsHref || !this.entity, html`
        <div class="container">
          <bn-icon-bin></bn-icon-bin>
          <span class="count">${this._renderTotalCount()}</span>
          <span class="divider">|</span>
        </div>
      `)}
    `;
  }

  _renderTotalCount() {
    if (!this.entity) {
      return html`<bn-icon name="fas fa-spinner fa-pulse"></bn-icon>`;
    }
    return html`<bins-configured-count .href="${this.binsHref}"></bins-configured-count>`;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.binsHref = this.getHref('https://api.binsentry.com/rel/v2/bins');
  }
}

window.customElements.define('organization-bin-count-header', OrganizationBinCountHeader);
